import { BrowserRouter as Router, Routes, Route, Outlet } from "react-router-dom";
import './App.css';
import Header from "./components/header/Header";
import { useTranslation } from "react-i18next";
import "./i18n";
import SessionManager from "./components/session-manager/SessionManager";
import ProtectedRoute from "./components/route-protection/ProtectedRoute";
import PhysioLogin from "./pages/physio-module/login-screen/LoginScreen";
import PhysioForgotPass from "./pages/physio-module/forgot-password/ForgotPassword";
import ForgotPassword from "./pages/forgot-password/ForgotPassword";
import PhysioResetPass from "./pages/physio-module/reset-password/ResetPassword";
import PhysioDashboard from "./pages/physio-module/dashboard/Dashboard";
import PhysioOrderManagement from "./pages/physio-module/physio-order-management/PhysioOrderManagement";
import PhysioAppointmentDetail from "./pages/physio-module/physio-appointment-detail/physio_appointment_detail";
import PhysioTherapyManagement from "./pages/physio-module/physio-management/PhysioTherapyManagement";
import PhysioEarningPayment from "./pages/physio-module/earning-payment/PhysioEarningPayment";
import PhysioEarningDetail from "./pages/physio-module/earning-detail/PhysioEarningDetail";
import PhysioServicesAndPricing from "./pages/physio-module/services-pricing/ServicesAndPricing";
import PhysioSetting from "./pages/physio-module/setting/Setting";
import PhysioChangePassword from "./pages/physio-module/change-password/ChangePassword";
import PhysioChat from "./pages/physio-module/chat/PhysioChat";
import PhysioChatList from "./pages/physio-module/chat-list/ChatList";
import PhysioProfile from "./pages/physio-module/physio-profile/PhysioProfile";
import PhysioOnboarding from "./pages/physio-module/physio-onboarding/PhysioOnboarding";
import PhysioWithdrawFromWallet from "./pages/physio-module/withdraw-from-wallet/WithdrawFromWallet";
import PublicPhysioAppointmentDetail from "./pages/physio-module/public-appointment-detail/PublicPhysioAppointmentDetail";
import PublicPhysioSessions from "./pages/physio-module/public-sessions/PublicPhysioSessions";
import { CustomToaster } from "./components/toast";
import AccountDeactivatedModal from "./components/account-deactivated/AccountDeactivatedModal";

function LayoutWithHeader({ changeLanguage }) {
  return (
    <>
      <Header changeLanguage={changeLanguage} />
      <Outlet /> 
    </>
  );
}

function App() {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    document.dir = (lang === "ar") ? "rtl" : "ltr";
  };

  return (
    <SessionManager>
      <CustomToaster />
      <div className="App">
        <Router>
          <Routes>
            {/* Public routes - No authentication required */}
            <Route element={<LayoutWithHeader changeLanguage={changeLanguage} />}>
              <Route path="/" element={<PhysioLogin />} />
              <Route path="/physio_forgot" element={<PhysioForgotPass />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/physio_reset" element={<PhysioResetPass />} />
            </Route>

            {/* Public therapist appointment page - no auth required */}
            <Route path="/public/appointment/:id" element={<PublicPhysioAppointmentDetail />} />
            <Route path="/public/sessions/:id" element={<PublicPhysioSessions />} />

            {/* Protected Physiotherapist routes (role_id: 8) */}
            <Route path="/physio_dashboard" element={<ProtectedRoute allowedRoleId={8} redirectTo="/"><PhysioDashboard /></ProtectedRoute>} />
            <Route path="/physio_ordermanagement" element={<ProtectedRoute allowedRoleId={8} redirectTo="/"><PhysioOrderManagement /></ProtectedRoute>} />
            <Route path="/physio_appointment_detail" element={<ProtectedRoute allowedRoleId={8} redirectTo="/"><PhysioAppointmentDetail /></ProtectedRoute>} />
            <Route path="/physio_therapy_management" element={<ProtectedRoute allowedRoleId={8} redirectTo="/"><PhysioTherapyManagement /></ProtectedRoute>} />
            <Route path="/physio_earning_payment" element={<ProtectedRoute allowedRoleId={8} redirectTo="/"><PhysioEarningPayment /></ProtectedRoute>} />
            <Route path="/physio_earning_detail" element={<ProtectedRoute allowedRoleId={8} redirectTo="/"><PhysioEarningDetail /></ProtectedRoute>} />
            <Route path="/physio_services" element={<ProtectedRoute allowedRoleId={8} redirectTo="/"><PhysioServicesAndPricing /></ProtectedRoute>} />
            <Route path="/physio_setting" element={<ProtectedRoute allowedRoleId={8} redirectTo="/"><PhysioSetting /></ProtectedRoute>} />
            <Route path="/physio_change_password" element={<ProtectedRoute allowedRoleId={8} redirectTo="/"><PhysioChangePassword /></ProtectedRoute>} />
            <Route path="/physio_chat" element={<ProtectedRoute allowedRoleId={8} redirectTo="/"><PhysioChat /></ProtectedRoute>} />
            <Route path="/physio_chatlist" element={<ProtectedRoute allowedRoleId={8} redirectTo="/"><PhysioChatList /></ProtectedRoute>} />
            <Route path="/physio_onboarding" element={<ProtectedRoute allowedRoleId={8} redirectTo="/" requireOnboarding={false}><PhysioOnboarding /></ProtectedRoute>} />
            <Route path="/physio_profile" element={<ProtectedRoute allowedRoleId={8} redirectTo="/"><PhysioProfile /></ProtectedRoute>} />
            <Route path="/physio_withdraw_from_wallet" element={<ProtectedRoute allowedRoleId={8} redirectTo="/"><PhysioWithdrawFromWallet /></ProtectedRoute>} />

            {/* unprotected routes for testing  */}

            {/* <Route path="/physio_dashboard" element={<PhysioDashboard />} />
            <Route path="/physio_ordermanagement" element={<PhysioOrderManagement />} />
            <Route path="/physio_appointment_detail" element={<PhysioAppointmentDetail />} />
            <Route path="/physio_therapy_management" element={<PhysioTherapyManagement />} />
            <Route path="/physio_earning_payment" element={<PhysioEarningPayment />} />
            <Route path="/physio_services" element={<PhysioServicesAndPricing />} />
            <Route path="/physio_setting" element={<PhysioSetting />} />
            <Route path="/physio_chat" element={<PhysioChat />} />
            <Route path="/physio_chatlist" element={<PhysioChatList />} />
            <Route path="/physio_profile" element={<PhysioProfile />} /> */}

          </Routes>
          {/* App-wide blocking modal shown when the account is deactivated. */}
          <AccountDeactivatedModal />
        </Router>
      </div>
    </SessionManager>
  );
}

export default App;